import React, { useState } from "react";
import WorklistSettings from "../../organisms/CollectionSettings";
import { CollectionsDashboard } from "../../organisms/CollectionsDashboard";
import { ProfileForm } from "../../organisms/ProfileForm";
import SettingsDrawer from "../../organisms/SettingsDrawer/SettingsDrawer";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    client: any;
    enableQueueViews?: boolean
}

const QueueSettingsDrawer: React.FC<IProps> = ({ isOpen, onClose, client, enableQueueViews = false }) => {
    const [showDetails, setShowDetails] = useState(false);
    const [directoryType, setDirectoryType] = useState("collection");
    const [selected, setSelected] = useState({});

    const showForm = (profile: any, show: boolean) => {
        setSelected(profile);
        setShowDetails(show);
    };

    const queueProfile = () => {
        return (
            <>
                {showDetails ? (
                    <ProfileForm
                        client={client}
                        showForm={showForm}
                        existingProfile={selected}
                        enableQueueViews={enableQueueViews}
                    />
                ) : (
                    <WorklistSettings
                        DirectoryType={directoryType}
                        client={client}
                        showForm={showForm}
                    />
                )}
            </>
        );
    };

    const workerCollection = () => {
        return (
            <WorklistSettings
                DirectoryType={directoryType}
                client={client}
                setShowDetails={setShowDetails}
            />
        );
    };

    const getSubtitle = () => {
        return directoryType === "collection" ? "Queues" : "Distribution";
    };

    return (
        <SettingsDrawer
            isOpen={isOpen}
            onClose={onClose}
            title="Queue Settings"
            subtitle={getSubtitle()}
        >
            <CollectionsDashboard
                queueProfile={queueProfile}
                coderDistribution={workerCollection}
                setDirectoryType={setDirectoryType}
                showDetails={showDetails}
                setShowDetails={setShowDetails}
                tabs={[
                    { label: "Queues", value: "collection" },
                    { label: "Distribution", value: "distribution" },
                ]}
            />
        </SettingsDrawer>
    );
};

export default QueueSettingsDrawer;
